const __set_token = require(`nllib/src/model/set_token`);
const dict_const = require(`../../../dicts/dict_const`);

const set_token = function (pParameter) {
  if (!pParameter) {
    pParameter = {};
  }

  const token = pParameter.token;
  const key = dict_const.map.haolv_token_cache_key;

  return __set_token({
    key,
    token,
  });
};

module.exports = set_token;
